export function SkipLink() {
  return (
    <a
      className='sr-only absolute top-2 left-2 z-10 block rounded border border-yellow-600 bg-yellow-300 text-sm text-stone-800 focus:not-sr-only focus:absolute focus:p-2'
      href='#main-content'
    >
      Skip to main content
    </a>
  )
}
